module.exports = __webpack_public_path__ + "static/media/inviteCopy.ac570ba0.svg";